module.exports = __webpack_public_path__ + "img/how-to-get-request.e6fc2106.svg";